import { on } from "events";
import { SiteData } from "../Data/SiteData";
import { GetCanvasFontScaleCSS } from "../CanvasFontScaleObserver";
import SliderField from "../StyleInputs/SliderFeild";
import { useMemo, useState } from "react";
import { CreateBlankLayoutNode } from "../WBCanvas";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { AttributeDefinition, AttributeInputType, AttributeTargetType, CreateRange } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { GetScreensizeIcon } from "../Icons/ScreenSizeIcons";
import ToggleLine from "../Utilities/ToggleLine";

export default function FontScalingMenu({ siteData }: { siteData: SiteData }) {


    const [useScaling, setUseScaling] = useState(siteData.siteStyling.useFontScaling);

    //since the exisiting slider fields are built to work with attribute definitions and attribute collections just create new ones instead of rewriting a new slider field
    const obj = useMemo(() => {

        let o = CreateBlankLayoutNode(wBComponentTypeNames.container);
        o.componentAttributes = {
            desktop: siteData.siteStyling.desktopFontSize.toString(),
            tablet: siteData.siteStyling.tabletFontSize.toString()
            , mobile: siteData.siteStyling.mobileFontSize.toString()
        }

        return o;
    }, [])

    const definitions = useMemo(() => {
        let desktop = new AttributeDefinition("desktop", "Text Scaling Min", "", AttributeInputType.RangeSliderField, [], CreateRange(8, 32, 1, "px", 16), AttributeTargetType.Component);
        let tablet = new AttributeDefinition("tablet", "Text Scaling Max", "", AttributeInputType.RangeSliderField, [], CreateRange(8, 32, 1, "px", 16), AttributeTargetType.Component);
        let mobile = new AttributeDefinition("mobile", "Text Scaling Max", "", AttributeInputType.RangeSliderField, [], CreateRange(8, 32, 1, "px", 16), AttributeTargetType.Component);
        return { desktop, tablet, mobile };
    }, [])

    const onUpdate = (num: number, screenSize:ScreenSize) => {

        switch (screenSize) {
            case ScreenSize.Desktop:
                siteData.siteStyling.desktopFontSize = num;
                break;
            case ScreenSize.Tablet:
                siteData.siteStyling.tabletFontSize = num;
                break;
            case ScreenSize.Mobile:
                siteData.siteStyling.mobileFontSize = num;
                break;

        }


        siteData.isStylePublishDirty = true;
        siteData.isStyleSaveDirty = true;
        //siteData.onUpdateStyle();

        let styleTarget = document.getElementById("font-scaling-styling") as HTMLElement;
        let canvas = document.getElementById("v-canvas") as HTMLElement;
        if (styleTarget && canvas) {

            styleTarget.innerHTML = GetCanvasFontScaleCSS(siteData.siteStyling, canvas.clientWidth);
        }

    }



    return <>          <h2 className="panel-heading">Text Scaling</h2>
<div className="wb-input-group">
    <ToggleLine label="Use Dynamic Text Scaling" toggledOn={siteData.siteStyling.useFontScaling} onChange={(val:boolean) => {
            siteData.siteStyling.useFontScaling = val;
            siteData.isStylePublishDirty = true;
            siteData.isStyleSaveDirty = true;
              let styleTarget = document.getElementById("font-scaling-styling") as HTMLElement;
                let canvas = document.getElementById("v-canvas") as HTMLElement;
                if (styleTarget && canvas) {

                    styleTarget.innerHTML = GetCanvasFontScaleCSS(siteData.siteStyling, canvas.clientWidth);
                }
            setUseScaling(val);

        } } description={"Scale the font size dynmacally based on screen size and view width."} checkRef={undefined} />
</div>
             <SliderField
                hideUpdating={true}
                label={<div className="flex-row gap-med"> <GetScreensizeIcon screenSize={ScreenSize.Desktop} /> Desktop Font Size</div>}
                definition={definitions.desktop} layoutObject={obj}
                updateFunc={(att, val) => {
                    let parsed = parseInt(val.replace("px", ""));
                    onUpdate(parsed, ScreenSize.Desktop);
                }} screenSize={ScreenSize.Desktop}
                saveFunc={() => { }}
                siteData={siteData} />
        {<> <SliderField
                hideUpdating={true}
                label={<div className="flex-row gap-med"> <GetScreensizeIcon screenSize={ScreenSize.Tablet} /> Tablet Font Size</div>}
                definition={definitions.tablet} layoutObject={obj}
                updateFunc={(att, val) => {
                    let parsed = parseInt(val.replace("px", ""));
                    onUpdate(parsed, ScreenSize.Tablet);
                }} screenSize={ScreenSize.Desktop}
                saveFunc={() => { }}
                siteData={siteData} />

            <SliderField
                hideUpdating={true}
                label={<div className="flex-row gap-med"> <GetScreensizeIcon screenSize={ScreenSize.Mobile} /> Mobile Font Size</div>}
                definition={definitions.mobile} layoutObject={obj}
                updateFunc={(att, val) => {
                    let parsed = parseInt(val.replace("px", ""));
                    onUpdate(parsed, ScreenSize.Mobile);
                }} screenSize={ScreenSize.Desktop}
                saveFunc={() => { }}
                siteData={siteData} />
</>
            }

       </>


}